import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/main.css'

// Create app first
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

// Mount the app
app.mount('#app')

// Initialize auth BEFORE anything else
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()
authStore.initialize()

// Initialize dark mode (non-blocking, with error handling)
import { useUIStore } from '@/stores/ui'
const uiStore = useUIStore()
try {
  uiStore.initializeDarkMode()
} catch (error) {
  console.error('Dark mode initialization failed:', error)
}

// Initialize PWA store and service worker (non-blocking)
import { usePWAStore } from '@/stores/pwa'
const pwaStore = usePWAStore()

// Initialize network listeners and install prompt detection
pwaStore.initialize()

// Register PWA service worker (production only)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  import('virtual:pwa-register')
    .then(({ registerSW }) => {
      const updateSW = registerSW({
        immediate: false,
        onNeedRefresh() {
          console.log('New content available')
          pwaStore.setNeedRefresh(true)
        },
        onOfflineReady() {
          console.log('App ready to work offline')
          pwaStore.setOfflineReady(true)
        },
        onRegisteredSW(swUrl, registration) {
          console.log('Service Worker registered:', swUrl)
          // Check for updates every hour
          if (registration) {
            setInterval(() => {
              registration.update()
            }, 60 * 60 * 1000)
          }
        },
        onRegisterError(error) {
          console.error('Service Worker registration error:', error)
        }
      })
      // Store the update function for later use
      pwaStore.setUpdateServiceWorker(updateSW)
    })
    .catch((error) => {
      console.warn('PWA not available:', error.message)
    })
}

// Initialize Sentry (production only, async, non-blocking)
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  import('@sentry/vue')
    .then(({ init, BrowserTracing, Replay }) => {
      init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
          new BrowserTracing({
            routingInstrumentation: (cb) => {
              router.beforeEach((to, from, next) => {
                cb({ op: 'navigation', description: to.path })
                next()
              })
            },
          }),
          new Replay({
            maskAllText: true,
            blockAllMedia: true,
          }),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
      })
    })
    .catch((error) => {
      console.warn('Sentry initialization failed:', error.message)
    })
}


